import moment from 'moment';
import { TIPO_DOC } from './constants';

export * from './constants';
export * from './excel';

export const containsDoc = (str, doc) => str.includes(doc);
export const containsLowercase = str => /[a-z]/.test(str);
export const containsUppercase = str => /[A-Z]/.test(str);
export const containsNumber = str => /\d/.test(str);
export const containsLetter = str => /[A-Za-z]/.test(str);
export const containsNumberLetter = str => containsNumber(str) && containsLetter(str);
export const validLicensePlate = license => /^[A-Z]{3} ?\d{4}$/.test(license);
export const containsWord = (str, w) => str.includes(w);

/* PASSWORD */
export const encodePassword = password => Buffer.from(password).toString('base64');

// export const validatePassword = (psw, ci = '', rut = '', nroAsegurado = '') => (
//   psw.length >= 8
//   && containsUppercase(psw)
//   && containsLowercase(psw)
//   && containsNumberLetter(psw)
//   && (!ci || !containsDoc(psw, ci))
//   && (!rut || !containsDoc(psw, rut))
//   && (!nroAsegurado || !containsDoc(psw, nroAsegurado))
// );

export const validatePassword = (password) => {
  if (password.length < 12) {
    return false;
  }

  const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
  if (!specialCharacters.test(password)) {
    return false;
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);

  if (!hasLetter || !hasNumber || !hasUppercase || !hasLowercase) {
    return false;
  }

  return true;
}


/* EMAIL */
export const validateEmail = (email) => {
  const re = /^(([^<>()\]\\.,;:\s@']+(\.[^<>()\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

/* VALIDACION DE CI Y RUT */
const ciValidationDigit = (ciParam: string) => {
  let ci = ciParam;
  ci = ci.substr(0, ci.length - 1);

  let suma = 0;
  let i = 0;
  const factores = [2, 9, 8, 7, 6, 3, 4];
  if (ci.length <= 6) {
    for (i = ci.length; i < 7; i++) {
      ci = '0' + ci;
    }
  }
  for (i = 0; i < 7; i++) {
    suma += (factores[i] * parseInt(ci[i], 10)) % 10;
  }
  if (suma % 10 === 0) {
    return 0;
  }
  return (10 - (suma % 10)) + '';
};

const rutValidationDigit = (rutParam: string) => {
  let rut = rutParam;
  if (rut.length === 11) {
    rut = '0' + rut;
  }
  let dig;
  let suma = 0;
  let modulo = 0;
  const factores = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  for (let i = rut.length - 2; i >= 0; i--) {
    suma += parseInt(rut[i], 10) * factores[i];
  }
  modulo = suma % 11;
  dig = 11 - modulo;
  if (dig === 11) {
    dig = 0;
  }
  if (dig === 10) {
    dig = 1;
  }

  return dig + '';
};

export const validateCI = (val: string): boolean => {
  // Validación de CI

  // Obtener solo los número sin puntos ni guiones
  const doc = val.replace(/\D/g, '');
  // Obtengo el digito verificador del doc que me pasan
  const dig = doc[doc.length - 1];
  // Valido el largo del documento y comparo el digito verificador con el calculado
  const ciValid = doc.length <= 8 && dig === ciValidationDigit(doc);
  let containsOtherThanZero = false;
  for (let i = 0; i < doc.length; i++) {
    if (doc[i] !== '0') {
      containsOtherThanZero = true;
      break;
    }
  }
  if (!ciValid || !containsOtherThanZero) {
    return false; // "El formato de la CI no es válido"
  }
  return true;
};

export const validateRUT = (val) => {
  // Validación de RUT

  // Obtener solo los número sin puntos ni guiones
  const doc = val.replace(/\D/g, '');
  // Idem que en ci, solo cambia el algoritmo al que llamo y el largo
  const dig = doc[doc.length - 1];
  const rutValid = doc.length <= 12 && dig === rutValidationDigit(doc);
  let containsOtherThanZero = false;
  for (let i = 0; i < doc.length; i++) {
    if (doc[i] !== '0') {
      containsOtherThanZero = true;
      break;
    }
  }
  if (!rutValid || !containsOtherThanZero) {
    return false; // "El formato del RUT no es válido"
  }
  return true;
};

/* STRINGS */
export const capitalize = (lower: string) => (lower ? lower.toLowerCase() : lower).replace(/(?:^|\s)\S/g, a => a.toUpperCase());

/* DATES */
// dateString format dd/mm/YYYY
export const stringToDate = (dateString) => {
  const date = dateString.split('/');
  if (date.length === 3) return new Date(date[2], date[1] - 1, date[0]);

  return new Date();
};

export const dateToString = date => `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

export const getDiffFromTodayInDays = (date) : number => {
  const date1 = new Date();
  const date2 = new Date(date);
  const timeDiff = date2.getTime() - date1.getTime();
  const daysDiff = timeDiff / (1000 * 3600 * 24);

  return Math.abs(Math.ceil(daysDiff));
};

export const mapSelectList = (list, value = 'clave', label = 'valor') => (
  list ? list.map((obj) => {
    const rObj = {};
    rObj.value = obj[value];
    rObj.label = obj[label];
    return rObj;
  }) : null);


/* OTHERS */
export const payments = (rate) => {
  const paymentsAux = [];

  rate.forEach((obj) => {
    if (obj.FeeAmount && obj.FeeAmount !== 0) {
      paymentsAux.unshift({ value: obj.FeeAmount, label: obj.FeeAmount + ' cuotas' });
    }
  });

  return paymentsAux;
};

/* Ciudades de Canelones deshabilitadas */
export const disabledCities = [
  30, 101, 151, 813, 816, 817, 818, 819, 820, 821, 822, 823, 824,
  825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 840, 841,
];

/* Códigos para Ciudades */
export const cityCodes = [
  { label: 'MONTEVIDEO', code: 1 }, { label: 'ARTIGAS', code: 11 },
  { label: 'CERRO LARGO', code: 131 }, { label: 'COLONIA', code: 153 },
  { label: 'DURAZNO', code: 211 }, { label: 'FLORES', code: 241 },
  { label: 'FLORIDA', code: 271 }, { label: 'LAVALLEJA', code: 301 },
  { label: 'MALDONADO', code: 331 }, { label: 'PAYSANDU', code: 371 },
  { label: 'RIO NEGRO', code: 421 }, { label: 'RIVERA', code: 461 },
  { label: 'ROCHA', code: 481 }, { label: 'SALTO', code: 521 },
  { label: 'SAN JOSE', code: 551 }, { label: 'SORIANO', code: 581 },
  { label: 'TACUAREMBO', code: 621 }, { label: 'TREINTA Y TRES', code: 65 },
];

/* Códigos para Deptos */
export const deptoCodes = [
  { label: 'MONTEVIDEO', code: 1 }, { label: 'ARTIGAS', code: 2 },
  { label: 'CANELONES', code: 3 },
  { label: 'CERRO LARGO', code: 4 }, { label: 'COLONIA', code: 5 },
  { label: 'DURAZNO', code: 6 }, { label: 'FLORES', code: 7 },
  { label: 'FLORIDA', code: 8 }, { label: 'LAVALLEJA', code: 9 },
  { label: 'MALDONADO', code: 10 }, { label: 'PAYSANDU', code: 11 },
  { label: 'RIO NEGRO', code: 12 }, { label: 'RIVERA', code: 13 },
  { label: 'ROCHA', code: 14 }, { label: 'SALTO', code: 15 },
  { label: 'SAN JOSE', code: 16 }, { label: 'SORIANO', code: 17 },
  { label: 'TACUAREMBO', code: 18 }, { label: 'TREINTA Y TRES', code: 19 },
];

/* Códigos para Genero */
export const genreCodes = [
  { label: 'Femenino', code: 'F' }, { label: 'Masculino', code: 'M' }
];

export const associatedDocText = (docType) => {
  if (docType === TIPO_DOC.RUT) {
    return 'Documento asociado - RUT';
  }
  if (docType === TIPO_DOC.CI) {
    return 'Documento asociado - CI';
  }
  return 'Documento asociado - Documento extranjero';
};

export const dateAlert = (date) => {
  const today = new Date();
  const dateVto = stringToDate(date);
  const diffTime = Math.abs(today - dateVto);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if ((diffDays <= 3 && dateVto >= today) || diffDays === 1) {
    return ('Vence en ' + diffDays + ' días');
  }
  return date;
};

/**
 * Recibe codCoin o coinDescription y retorna el simbolo UYU o USD
 * @param {number | string} value
 */
export const getCurrencySymbol = (value) => {
  let symbol;

  switch (value) {
    case '$':
    case 0:
    case 'PESOS URUGUAYOS':
      symbol = 'UYU';
      break;
    case 1:
    case 'DOLARES U.S.A.':
      symbol = 'USD';
      break;
    default:
      symbol = 'UYU';
      break;
  }

  return symbol;
};

/**
 * Recibe el id del tipo y devuelvo el nombre
 * @param {number} value
 */
export const getInvoiceTypeString = (value) => {
  let name;

  switch (value) {
    case 111:
      name = 'Factura'
      break;
    case 112:
      name = 'Nota de crédito'
      break;
    default:
      name = 'Factura'
      break;
  }

  return name;
};

export const driverRequestBalanceText = (availableServices) => {
  if(availableServices === 0) return 'No hay servicios disponibles';
  if(availableServices === 1) return availableServices + ' servicio disponible';
  return availableServices + ' servicios disponibles';
};

// Posiciones en donde se muestran las preguntas
export const questionsPositions = [
  0, 4, 8
];

export const isValidFile = (type, size) => {
  const types = [
    'image/jpg', 
    'image/jpeg',
    'image/png',
    'application/pdf',
  ];

  /* 10MB maximo */
  if (size > (10485760 / 2)) {
    return false;
  }

  if (!types.includes(type)) {
    return false;
  }

  return true;
};

export const sortList = (type, key, order, list) => {
  const newList = [...list];
  switch (type) {
    case 'letter':
      newList.sort((a, b) => {
        if (a[key] > b[key]) { return 1 * order; }
        if (b[key] > a[key]) { return -1 * order; }
        return 0;
      });
      break;
    case 'number':
      newList.sort((a, b) => ((a[key] || 0) - (b[key] || 0)) * order);
      break;
    case 'date':
      newList.sort((a, b) => (moment(a[key]) - moment(b[key])) * order);
      break;
    default:
      newList.sort((a, b) => (a[key] - b[key]) * order);
      break;
  }
  return newList;
};

export const findPosWithAttrName = (array, key1, key2) => {
  for(let i = 0; i < array.length; i += 1) {
      if(array[i][key1] === key2) {
          return i;
      }
  }
  return -1;
}